import Vue from "vue"
import Router from "vue-router"

Vue.use(Router)

const routes = [
    {
        path: '/',
        component: () => import('@/views/noc/index.vue'),
        name:'noc',
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/login',
        component: () => import('@/views/login/index2024.vue'),
        name: 'login',
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/studentComplier',
        name:'StudentComplier',
        component: () => import('@/views/studentComplier/studentComplier.vue'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/exam',
        name:  'Exam',
        component: () => import('@/views/exam/exam.vue'),
        meta: {
            requiresAuth: true,
        },
    }
]
const router = new Router({ routes });
router.beforeEach((to, from, next) => {
    if(to.matched.some(record => record.meta.requiresAuth)) {
        // const userInfo = store.state.user.userInfo || {};
        // const token = userInfo.token || userInfo.accessToken || '';
        const tokenKey = 'NOC_XILIE_CP_2024'// !to.query.id ? `ALGC_XILIE_CP_2023` : `ALGC_XILIE_CP_${to.query.id}`
        const token = sessionStorage.getItem(tokenKey)
        if (token) {
            next();
        } else {
            to.query.id ? next({path: '/login',query: {id: to.query.id}}) : next('/login')
        }
    } else {
        next() 
    }
});

// router.afterEach((to) => {
//     ClientMonitor.setPerformance({
//         service: process.env.VUE_APP_SERVICE_NAME,
//         serviceVersion: config.version,
//         pagePath: to.name,
//     });
// });

export { router };